import { fromJS } from "immutable"
import {
  GET_LIST_MULTIPLE_CHOICE_QUESTIONS_WATCHER,
  GET_LIST_MULTIPLE_CHOICE_QUESTIONS_SUCCESS,
  GET_LIST_MULTIPLE_CHOICE_QUESTIONS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  listMultipleChoiceQuestions: [],
})

function widgetMultipleChoiceQuestionsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LIST_MULTIPLE_CHOICE_QUESTIONS_WATCHER:
      return state.set("isLoading", true)

    case GET_LIST_MULTIPLE_CHOICE_QUESTIONS_SUCCESS:
      return state
        .set("isLoading", false)
        .set(
          "listMultipleChoiceQuestions",
          Array.isArray(action.payload) ? action.payload : []
        )

    case GET_LIST_MULTIPLE_CHOICE_QUESTIONS_FAILED:
      return state
        .set("isLoading", false)
        .set("listMultipleChoiceQuestions", [])

    default:
      return state
  }
}

export default widgetMultipleChoiceQuestionsReducer
